export type FormType = "email" | "emailName" | "emailPhone" | "emailState"

interface FormTypeFields {
  firstName: boolean
  phone: boolean
  state: boolean
}

const FORM_TYPE_FIELDS: Record<FormType, FormTypeFields> = {
  email: { firstName: false, phone: false, state: false },
  emailName: { firstName: true, phone: false, state: false },
  emailPhone: { firstName: false, phone: true, state: false },
  emailState: { firstName: false, phone: false, state: true },
}

export function resolveFormType(value?: string): FormType {
  if (value && value in FORM_TYPE_FIELDS) return value as FormType
  return "emailState"
}

export function formTypeFields(value?: string): FormTypeFields {
  return FORM_TYPE_FIELDS[resolveFormType(value)]
}
